import React from "react";
import ContabilidadeDashboard from "../../components/PortalHome/Contabilidade/Dashboard";

function PageDashboardContabilidade() {
  return (
    <div className="centralizar" style={{ background: '#f8fafc', minHeight: '100vh', padding: '24px' }}>
      <ContabilidadeDashboard />
    </div>
  );
}

export default PageDashboardContabilidade;
